import createIcon from '../../icons/createIcon';

const IconLoadingCircleDark = createIcon('IconLoadingCircleDark', '0 0 64 64', [
    [
        'g',
        {
            'clip-path': 'url(#paint0_angular_406_11507_clip_path)',
            'data-figma-skip-parse': 'true',
            key: '17fdb8'
        },
        [
            {
                name: 'g',
                type: 'element',
                value: '',
                parent: null,
                attributes: {
                    transform: 'matrix(0.024 5.95646e-05 -5.95646e-05 0.024 32 32)',
                    key: 'dea056'
                },
                children: [
                    {
                        name: 'foreignObject',
                        type: 'element',
                        value: '',
                        parent: null,
                        attributes: {
                            x: '-1086.02',
                            y: '-1086.02',
                            width: '2172.03',
                            height: '2172.03',
                            key: '6aa2b0'
                        },
                        children: [
                            {
                                name: 'div',
                                type: 'element',
                                value: '',
                                parent: null,
                                attributes: {
                                    xmlns: 'http://www.w3.org/1999/xhtml',
                                    style: 'background:conic-gradient(from 90deg,rgba(18, 21, 27, 1) 0deg,rgba(7, 20, 38, 0.05) 269.818deg,rgba(7, 20, 38, 0) 315deg,rgba(18, 21, 27, 1) 360deg);height:100%;width:100%;opacity:1',
                                    key: 'f8c856'
                                },
                                children: []
                            }
                        ]
                    }
                ]
            }
        ]
    ],
    [
        'path',
        {
            d: 'M18.666 12.0449C23.2825 8.96027 28.8261 7.57123 34.3516 8.11523C39.8774 8.65948 45.0445 11.1031 48.9707 15.0293L43.3145 20.6855C40.697 18.0681 37.2522 16.439 33.5684 16.0762C29.8845 15.7133 26.1892 16.6407 23.1113 18.6973C20.0336 20.7538 17.764 23.8132 16.6895 27.3555C15.6149 30.8978 15.8022 34.7031 17.2188 38.123C18.6353 41.5427 21.1927 44.3664 24.457 46.1113C27.7215 47.8562 31.4907 48.4154 35.1211 47.6934C38.7516 46.9712 42.0208 45.0118 44.3691 42.1504C46.7173 39.289 48 35.7015 48 32H56C56 37.5522 54.0748 42.9326 50.5527 47.2246C47.0303 51.5168 42.1275 54.4558 36.6816 55.5391C31.236 56.6221 25.5823 55.7834 20.6855 53.166C15.789 50.5485 11.9509 46.3132 9.82617 41.1836C7.70168 36.054 7.42152 30.3463 9.0332 25.0332C10.645 19.7199 14.0494 15.1297 18.666 12.0449Z',
            'data-figma-gradient-fill':
                '{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.070588238537311554,&#34;g&#34;:0.082352943718433380,&#34;b&#34;:0.10588235408067703,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.027450980618596077,&#34;g&#34;:0.078431375324726105,&#34;b&#34;:0.14901961386203766,&#34;a&#34;:0.050000000745058060},&#34;position&#34;:0.74949485063552856},{&#34;color&#34;:{&#34;r&#34;:0.027450980618596077,&#34;g&#34;:0.078431375324726105,&#34;b&#34;:0.14901961386203766,&#34;a&#34;:0.0},&#34;position&#34;:0.8750}],&#34;stopsVar&#34;:[],&#34;transform&#34;:{&#34;m00&#34;:47.999988555908203,&#34;m01&#34;:-0.11912918835878372,&#34;m02&#34;:8.0595760345458984,&#34;m10&#34;:0.11912916600704193,&#34;m11&#34;:47.999988555908203,&#34;m12&#34;:7.9404435157775879},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}',
            key: '8ecfbd'
        },
        []
    ],
    [
        'defs',
        {
            key: '501799'
        },
        [
            {
                name: 'clipPath',
                type: 'element',
                value: '',
                parent: null,
                attributes: {
                    id: 'paint0_angular_406_11507_clip_path',
                    key: '102537'
                },
                children: [
                    {
                        name: 'path',
                        type: 'element',
                        value: '',
                        parent: null,
                        attributes: {
                            d: 'M18.666 12.0449C23.2825 8.96027 28.8261 7.57123 34.3516 8.11523C39.8774 8.65948 45.0445 11.1031 48.9707 15.0293L43.3145 20.6855C40.697 18.0681 37.2522 16.439 33.5684 16.0762C29.8845 15.7133 26.1892 16.6407 23.1113 18.6973C20.0336 20.7538 17.764 23.8132 16.6895 27.3555C15.6149 30.8978 15.8022 34.7031 17.2188 38.123C18.6353 41.5427 21.1927 44.3664 24.457 46.1113C27.7215 47.8562 31.4907 48.4154 35.1211 47.6934C38.7516 46.9712 42.0208 45.0118 44.3691 42.1504C46.7173 39.289 48 35.7015 48 32H56C56 37.5522 54.0748 42.9326 50.5527 47.2246C47.0303 51.5168 42.1275 54.4558 36.6816 55.5391C31.236 56.6221 25.5823 55.7834 20.6855 53.166C15.789 50.5485 11.9509 46.3132 9.82617 41.1836C7.70168 36.054 7.42152 30.3463 9.0332 25.0332C10.645 19.7199 14.0494 15.1297 18.666 12.0449Z',
                            key: 'f298fb'
                        },
                        children: []
                    }
                ]
            }
        ]
    ]
]);

export { IconLoadingCircleDark };
